<template>
  <div class="row order-history__title" id="order-history-show-title">
    <div class="col-12" id="title-col">
      <div
        class="plugin__title d-flex flex-row justify-content-between order-history__plugin-title"
        id="suite-nav"
      >
        {{
          lang.get('event_strings.attendee_orders_page.show_title', {
            orderNumber
          })
        }}
      </div>
      <!-- back button with left arrow using font awesome -->

      <EcommerceReceipt
        v-if="order && receipt"
        :itemized-receipt="receipt"
        :order="order"
        :existing-requests="order.attendee_order_requests"
        :current-event="event"
        insert-html
      >
        <template #header>
          <div class="order-history__back-button">
            <a
              class="py-2"
              id="back-button"
              @click="$router.go(-1)"
              v-if="order"
            >
              <i class="fas fa-arrow-left"></i>
              {{ lang.get('event_strings.back_button') }}
            </a>
          </div>
          <div
            v-if="
              order && order.event && order.event.attendee_orders_show_page_header
            "
            v-html="order.event.attendee_orders_show_page_header"
          ></div>
          <h3
            v-else
            id="ecommerce-receipt-title"
            class="ecommerce-receipt-title"
          >
            Order Details
          </h3>
        </template>
      </EcommerceReceipt>
    </div>
  </div>
</template>

<script>
import EcommerceReceipt from './EcommerceReceipt.vue';
export default {
  name: 'AttendeeOrderHistoryShow',
  data: () => ({
    order: null,
    receipt: null,
    orderNumber: null,
    errorMessages: []
  }),
  components: {
    EcommerceReceipt
  },
  methods: {
    fetchOrder() {
      Http.makeRequest(
        'GET',
        Routes.show({ id: this.orderNumber }),
        {},
        this.handleFetchSuccess,
        this.handleFetchError
      );
    },
    handleFetchSuccess(data) {
      EventBus.$emit('order-fetched', data.order);
      console.log(data);
      this.order = data.order;
      this.receipt = data.itemizedReceipt;
      this.event = data.event;
    },
    handleFetchError(error) {
      EventBus.$emit('order-fetch-failed', error);
      console.log(error);
    }
  },
  mounted() {
    // set the order number from the route parameter
    this.orderNumber = this.$route.params.id ?? null;
    this.fetchOrder();
  }
};
</script>

<style scoped>
</style>